module.exports = __webpack_public_path__ + "static/media/placeholder-collection.282a0a73.png";